import _extends from "@babel/runtime/helpers/extends";
import { stringifyForDataLayer } from '../../analytics/google/helpers';
import { transformProductConfig, hasPrice } from './productConfigTransformer';
export default function inventoryTransformer(inventory, options, inheritPageData, includeWalletData) {
  var _inventory$owner, _inventory$owner$id, _inventory2, _inventory2$owner, _inventory$descriptio, _inventory$additional, _inventory$driveType, _inventory$engine, _inventory$specificat, _inventory$specificat2, _inventory$color, _specifications$mpg, _inventory$fuelType, _inventory$make, _miles$value, _inventory$model, _inventory$pricingDet, _inventory$pricingDet2, _inventory$transmissi, _inventory$trim;
  if (inventory === void 0) {
    inventory = {};
  }
  if (inheritPageData === void 0) {
    inheritPageData = true;
  }
  if (includeWalletData === void 0) {
    includeWalletData = false;
  }
  var _inventory = inventory,
    specifications = _inventory.specifications,
    mileage = _inventory.mileage,
    owner = _inventory.owner,
    accelerate = _inventory.accelerate,
    creditApp = _inventory.creditApp,
    isWestlakePrequal = _inventory.isWestlakePrequal;
  var target = options.target,
    vehicleListingPosition = options.vehicleListingPosition,
    _options$dataLayer = options.dataLayer,
    dataLayer = _options$dataLayer === void 0 ? {} : _options$dataLayer,
    eventResult = options.eventResult,
    _options$onlyEcomDims = options.onlyEcomDims,
    onlyEcomDims = _options$onlyEcomDims === void 0 ? undefined : _options$onlyEcomDims;
  var inventorySellerType = owner != null && owner.privateSeller ? 'private-seller' : 'dealer';
  var miles = mileage || (specifications == null ? void 0 : specifications.mileage);
  var _transformProductConf = transformProductConfig({
      homeServices: _extends({}, owner == null ? void 0 : owner.homeServices, {
        accelerate: accelerate
      }),
      shippingLabel: owner == null ? void 0 : owner.shippingLabel,
      nds: hasPrice(inventory),
      westlake: isWestlakePrequal,
      creditApp: creditApp || accelerate
    }, includeWalletData),
    productConfiguration = _transformProductConf.productConfiguration;
  var translation = {};
  var bodyStyleCode = Array.isArray(inventory.bodyStyleCodes) ? inventory.bodyStyleCodes[0] : inventory.bodyStyleCodes;
  var style = Array.isArray(inventory.style) ? inventory.style[0] : inventory.style;
  var inventoryDetails = {
    bodyStyle: bodyStyleCode || style,
    chromeStyleId: inventory.chromeStyleId || inventory.styleId,
    condition: inventory.listingType || inventory.type,
    dealershipId: (_inventory$owner = inventory.owner) == null ? void 0 : (_inventory$owner$id = _inventory$owner.id) == null ? void 0 : _inventory$owner$id.toString(),
    dealerDistance: (_inventory2 = inventory) == null ? void 0 : (_inventory2$owner = _inventory2.owner) == null ? void 0 : _inventory2$owner.distanceFromSearch,
    description: (_inventory$descriptio = inventory.description) != null && _inventory$descriptio.label || (_inventory$additional = inventory.additionalInfo) != null && _inventory$additional.vehicleDescription ? 'yes' : 'no',
    driveTrain: inventory.driveGroup || ((_inventory$driveType = inventory.driveType) == null ? void 0 : _inventory$driveType.name),
    engineType: ((_inventory$engine = inventory.engine) == null ? void 0 : _inventory$engine.name) || inventory.engine,
    exteriorColor: inventory.exteriorColorSimple || ((_inventory$specificat = inventory.specifications) == null ? void 0 : (_inventory$specificat2 = _inventory$specificat.exterior) == null ? void 0 : _inventory$specificat2.value) || ((_inventory$color = inventory.color) == null ? void 0 : _inventory$color.exteriorColorSimple),
    fuelEconomy: specifications == null ? void 0 : (_specifications$mpg = specifications.mpg) == null ? void 0 : _specifications$mpg.value,
    fuelType: ((_inventory$fuelType = inventory.fuelType) == null ? void 0 : _inventory$fuelType.name) || inventory.fuelType,
    listingId: inventory.id || inventory.listingId,
    makeId: inventory.makeCode,
    makeName: inventory.makeName || ((_inventory$make = inventory.make) == null ? void 0 : _inventory$make.name) || inventory.make,
    mileage: (miles == null ? void 0 : (_miles$value = miles.value) == null ? void 0 : _miles$value.replace(/[^0-9]/g, '')) || (miles == null ? void 0 : miles.toString().replace(/[^0-9]/g, '')),
    modelId: inventory.modelCode,
    modelName: inventory.modelName || ((_inventory$model = inventory.model) == null ? void 0 : _inventory$model.name) || inventory.model,
    price: ((_inventory$pricingDet = inventory.pricingDetail) == null ? void 0 : _inventory$pricingDet.salePrice) || ((_inventory$pricingDet2 = inventory.pricingDetail) == null ? void 0 : _inventory$pricingDet2.msrp),
    priorityType: typeof inventory.priority === 'object' ? null : inventory.priority,
    productConfiguration: productConfiguration,
    sellerType: inventorySellerType,
    series: inventory.classSeries,
    seriesId: inventory.classSeriesCode || inventory.series,
    transmission: inventory.transmissionGroup || ((_inventory$transmissi = inventory.transmission) == null ? void 0 : _inventory$transmissi.name),
    trimId: inventory.atTrim || inventory.trimCode,
    trimName: ((_inventory$trim = inventory.trim) == null ? void 0 : _inventory$trim.name) || inventory.trim,
    vehicleId: inventory.id || inventory.listingId,
    videoId: inventory.videoId,
    vin: inventory.vin,
    year: inventory.year
  };
  switch (target) {
    case 'ecommerce':
      {
        var _inventory$model2, _inventory$trim2, _miles$value2, _inventory$fuelType2, _specifications$mpg2, _specifications$engin, _specifications$drive, _inventory$pricingDet3, _inventory$pricingDet4, _inventory3, _inventory3$owner;
        var ecommerceDimensions = {
          // Vehicle Catalog
          dimension1: dataLayer.catalog,
          // Vehicle ID
          dimension3: inventory.id,
          // Vehicle Listing ID
          dimension4: inventory.id,
          // Vehicle Year
          dimension5: inventory.year,
          // Vehicle Make ID
          dimension6: inventory.makeCode,
          // Vehicle Model ID
          dimension8: inventory.modelCode,
          // Vehicle Market Model
          dimension10: ((_inventory$model2 = inventory.model) == null ? void 0 : _inventory$model2.name) || inventory.model,
          // Vehicle Series ID
          dimension11: inventory.classSeriesCode,
          // Vehicle Trim ID
          dimension12: inventory.atTrim || inventory.trimCode,
          // Vehicle Trim Name
          dimension13: ((_inventory$trim2 = inventory.trim) == null ? void 0 : _inventory$trim2.name) || inventory.trim,
          // Vehicle Type
          dimension14: inventory.type,
          // Vehicle Body Style
          dimension15: Array.isArray(inventory.style) ? inventory.style[0] : inventory.style,
          // Vehicle Condition
          dimension16: inventory.listingType || inventory.type,
          // Vehicle Mileage
          dimension17: (miles == null ? void 0 : (_miles$value2 = miles.value) == null ? void 0 : _miles$value2.replace(/[^0-9]/g, '')) || (miles == null ? void 0 : miles.toString().replace(/[\s,]+/g, '')),
          // Vehicle Fuel
          dimension18: ((_inventory$fuelType2 = inventory.fuelType) == null ? void 0 : _inventory$fuelType2.name) || inventory.fuelType,
          // Vehicle Fuel Econony
          dimension19: specifications == null ? void 0 : (_specifications$mpg2 = specifications.mpg) == null ? void 0 : _specifications$mpg2.value,
          // Vehicle Engine Type
          dimension20: specifications == null ? void 0 : (_specifications$engin = specifications.engine) == null ? void 0 : _specifications$engin.value,
          // Vehicle Drivetrain
          dimension21: specifications == null ? void 0 : (_specifications$drive = specifications.driveType) == null ? void 0 : _specifications$drive.value,
          // Vehicle Price
          dimension22: ((_inventory$pricingDet3 = inventory.pricingDetail) == null ? void 0 : _inventory$pricingDet3.salePrice) || ((_inventory$pricingDet4 = inventory.pricingDetail) == null ? void 0 : _inventory$pricingDet4.msrp),
          // Vehicle Seller Type
          dimension23: inventorySellerType,
          // Vehicle Product Configuration
          dimension24: productConfiguration,
          // Vehicle Listing Position
          dimension25: vehicleListingPosition,
          // Event Result
          dimension30: eventResult,
          // Dealer Priority Type
          dimension31: inventory.priority,
          // Dealership ID
          dimension33: owner ? owner.id : inventory.ownerId,
          // Dealer Distance
          dimension34: (_inventory3 = inventory) == null ? void 0 : (_inventory3$owner = _inventory3.owner) == null ? void 0 : _inventory3$owner.distanceFromSearch
        };
        if (onlyEcomDims !== undefined) {
          Object.keys(ecommerceDimensions).forEach(function (key) {
            if (!onlyEcomDims.includes(key)) delete ecommerceDimensions[key];
          });
        }
        translation = stringifyForDataLayer(ecommerceDimensions);
        break;
      }
    case 'pageData':
      {
        translation = stringifyForDataLayer(_extends({}, inventoryDetails));
        break;
      }
    case 'vehicle':
      {
        var _dataLayer$consumerIn;
        translation = stringifyForDataLayer(_extends({}, inventoryDetails, {
          catalog: dataLayer.catalog,
          clickType: inventory.clickType,
          subCategory: (_dataLayer$consumerIn = dataLayer.consumerInsights) == null ? void 0 : _dataLayer$consumerIn.pe_subcat,
          vehicleType: inventory.type
        }), inheritPageData);
        break;
      }
    case 'search':
      {
        translation = stringifyForDataLayer({
          catalog: dataLayer.catalog,
          yearMin: inventory.startYear || 'any',
          yearMax: inventory.endYear || 'any',
          makeName: inventory.makeCodeList,
          modelName: inventory.modelCodeList,
          seriesName: inventory.seriesCodeList,
          trimName: inventory.trimCodeList,
          bodyStyle: inventory.vehicleStyleCodes,
          vehicleCondition: inventory.listingTypes,
          mileage: inventory.maxMileage,
          // TODO: How should the price range look?
          price: inventory.minPrice && inventory.maxPrice ? inventory.minPrice + "-" + inventory.maxPrice : undefined,
          vehicleHistory: inventory.vhrTypes,
          sellerType: inventory.sellerTypes,
          productType: inventory.homeServices,
          radius: inventory.searchRadius,
          zipCode: inventory.zip,
          keywords: inventory.keywordPhrases
        });
        break;
      }
    case 'video':
      {
        var _inventory$make2, _inventory$model3;
        translation = stringifyForDataLayer(_extends({}, inventoryDetails, {
          clickType: inventory.clickType,
          catalog: dataLayer.catalog || undefined,
          year: inventory.year || undefined,
          makeId: inventory.makeCode || undefined,
          makeName: ((_inventory$make2 = inventory.make) == null ? void 0 : _inventory$make2.name) || inventory.make,
          modelId: inventory.modelCode || undefined,
          modelName: ((_inventory$model3 = inventory.model) == null ? void 0 : _inventory$model3.name) || inventory.model
        }));
        break;
      }
    default:
  }
  return translation;
}